{
  "_leia": "usar = \"cloud\" ou \"externo\"",
  "usar": "externo",
  "externo": {
    "host": "3.22.199.232",
    "porta": 5432,
    "usuario": "postgres",
    "senha": "rr2908BB",
    "banco": "sorvete",
    "ssl": false
  }
}
